import DOMPurify from "dompurify";

const ALLOWED_TAGS = [
  "p",
  "br",
  "div",
  "span",
  "strong",
  "b",
  "em",
  "i",
  "u",
  "a",
  "ul",
  "ol",
  "li",
];

function secureLinks(node: Element): void {
  if (node.tagName === "A") {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  }
}

/** Безопасный HTML для display-полей. */
export function sanitizeHtml(html: string): string {
  DOMPurify.addHook("afterSanitizeAttributes", secureLinks);
  try {
    return DOMPurify.sanitize(html, {
      ALLOWED_TAGS,
      ALLOWED_ATTR: ["href", "target", "rel"],
    });
  } finally {
    DOMPurify.removeHook("afterSanitizeAttributes", secureLinks);
  }
}
